/**
 * rails.tsx
 */
import Animator from '@components/elements/animator/animator';
import ChannelsRail from './rails/channelsRail';
import EpgTimeline from './epg/epgTimeline';
import FilterRail from './rails/filterRail';
import MainContext from '@shared/components/utils/context/mainContext';
import RailList from './rails/railList';
import Spinner from '@components/elements/spinner/spinner';
import { memo, useContext } from 'react';
import { selectMenuCollapse } from '@shared/store/slices/menu.slice';
import { useAppSelector } from '@shared/store/hooks';

function Rails() {
  const menuExpanded = !useAppSelector(selectMenuCollapse);
  const { config, loading } = useContext(MainContext);
  return config.display.rails ? (
    <Animator
      id={'railsContainer'}
      collapse={{
        horizontal: menuExpanded,
        // Timeline pages keep the rails below the description, which stays
        // visible with the menu expanded.
        vertical:
          menuExpanded &&
          config.display.rails &&
          !config.display.sliders &&
          !config.timeline,
      }}
      type={Animator.Type.RAILS}
    >
      <FilterRail />
      {loading ? (
        <Spinner type={config.spinner?.type} />
      ) : (
        <>
          <EpgTimeline />
          <ChannelsRail />
          <RailList />
        </>
      )}
    </Animator>
  ) : null;
}

export default memo(Rails);
